import { configureStore } from '@reduxjs/toolkit';
import organisationReducer from '../slices/organisationSlice';
import userReducer from '../slices/userSlice'; // Adjust the path
import sidebarReducer from "../slices/sidebarSlice";
import equipmentReducer from "@/slices/equipmentSlice.ts";
import serviceReducer from "@/slices/serviceSlice.ts";
import playerReducer from "@/slices/playerSlice.ts";
import facilityReducer from "@/slices/facilitySlice.ts";
import coachesReducer from "@/slices/coachesSlice.ts";
import campaignReducer from "@/slices/campaignSlice";
import educationReducer from "@/slices/educationSlice.ts";
import packagesReducer from "@/slices/packagesSlice.ts";

const store = configureStore({
    reducer: {
        user: userReducer,
        organisation: organisationReducer,
        sidebar: sidebarReducer,
        equipment: equipmentReducer,
        service: serviceReducer,
        player: playerReducer,
        coaches: coachesReducer,
        facility: facilityReducer,
        campaign: campaignReducer,
        education: educationReducer,
        packages: packagesReducer,
    },
});

// Export the store's type for use in components
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
